"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteSection = void 0;
const ui_1 = require("@app/component/ui");
const form_grid_layout_1 = require("@app/component/ui/forms/form-grid-layout");
const util_1 = require("@app/util");
const use_debounced_controller_1 = require("@app/util/forms/use-debounced-controller");
const react_1 = __importDefault(require("react"));
const shift_modal_section_1 = require("../components/shift-modal-section");
const shift_context_1 = require("../shift-context");
const NoteSection = () => {
    const { formControl, disabledEditation } = (0, shift_context_1.useShift)();
    const noteController = (0, use_debounced_controller_1.useDebouncedController)({
        control: formControl,
        name: 'note',
        ms: 300,
    });
    return (react_1.default.createElement(shift_modal_section_1.ShiftModalSection, { id: 'note' },
        react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
            react_1.default.createElement(ui_1.Input, { testid: 'note-input', type: 'text', size: 'full-width', label: (0, util_1.t)('NOTE'), 
                // @ts-expect-error
                innerRef: noteController.field.ref, value: noteController.field.value ?? undefined, onChange: noteController.field.onChange, disabled: (0, util_1.isDefined)(disabledEditation) }))));
};
exports.NoteSection = NoteSection;
